module.exports = __webpack_public_path__ + "img/Pages-icon.ttf?40da9d81137fee31522b202c59d4d7ee";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pages/fonts/pages-icon/Pages-icon.ttf?-u69vo5
// module id = 623
// module chunks = 0